var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleBilling(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,20.88H9.5c-.3,0-.54-.24-.54-.54v-5.8l4.61,3.84c.68,.57,1.55,.88,2.43,.88s1.75-.31,2.44-.88l4.61-3.84v5.8c0,.3-.24,.54-.54,.54ZM9.5,11.12h13c.3,0,.54,.24,.54,.54v.75l-5.65,4.68c-.79,.65-2.01,.65-2.79,0l-5.64-4.67v-.75c0-.3,.24-.54,.54-.54Zm13-1.62H9.5c-1.2,0-2.17,.97-2.17,2.17v8.67c0,1.2,.97,2.17,2.17,2.17h13c1.2,0,2.17-.97,2.17-2.17V11.67c0-1.2-.97-2.17-2.17-2.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBilling);
export default __webpack_public_path__ + "static/media/title-billing.609e1be2d3efa2910ed227acb54eb4c2.svg";
export { ForwardRef as ReactComponent };